import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconChevronDownComponent } from "./med-icon-chevron-down.component";

@NgModule({
  declarations: [
    MedIconChevronDownComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconChevronDownComponent,
  ],
})
export class MedIconChevronDownModule { }
